import { ConfiguracoesUsuario } from "./usuario/ConfiguracoesUsuario";

export class NavbarModel {
  public userNome: string;
  public userFoto: string;

  public static fromUserData(user: ConfiguracoesUsuario) {
    const ret = new NavbarModel();

    if (user) {
      ret.userNome = user.nome;
      ret.userFoto = user.foto;
    }

    return ret;
  }
}
